/**
 * StarPoints
 * ======================================
 */

 const ISMOBILE = window.matchMedia("only screen and (max-width: 767px)").matches
 const ELEMENTS = '.js-StarPoints'
 const SUB_ELEMENT = '.star-points-cards__item-text'
 const TOGGLE_CLASS = 'is-open'
 const DEFAULTACTIVECLASS = 'is-open-default'

 class StarPoints {
   constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements || !ISMOBILE) {
      return false;
    }

    this.elements.forEach((el) => {
      const nav = el.querySelectorAll('.star-points-cards__item-header')

      nav.forEach((navEl) => {
        navEl.addEventListener('click', this.toggle)
      })

      document.addEventListener('DOMContentLoaded', () => {
          this.initOpen(el)
      });

    });
   }

   initOpen = (widget) => {
     const activeTab = widget.querySelector('.star-points-cards__item.'+DEFAULTACTIVECLASS)

     if (!activeTab) {
      return false
     }

     const sub = activeTab.querySelector(SUB_ELEMENT)

     if (!sub) {
      return false
     }

     sub.style.height = sub.scrollHeight+'px'
     activeTab.classList.remove(DEFAULTACTIVECLASS)
  }

   toggle = (e) => {
    const el = e.currentTarget;
    const target = el.parentNode;
    const classes = target.classList
    const sub = target.querySelector(SUB_ELEMENT)

    if(classes.contains(TOGGLE_CLASS)){
      classes.remove(TOGGLE_CLASS)
      sub.style.height = 0
    } else {
      classes.add(TOGGLE_CLASS)
      sub.style.height = sub.scrollHeight+'px'
    }

    e.preventDefault();
  };
 }

 new StarPoints()
